import styled from "styled-components";

import { FlexDiv, Button, Box } from "../../../../../components/Atoms";
import Avatar from "@/components/Molecules/Avatar";
import Typography from "@/foundation/Typography/V2";

export const StyledWebinarVideoOverlay = styled(Box)`
  padding: 24px;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${({ theme }) => theme.colorsV2.gray.shade_900};
  background-image: ${({ bgImg }) => bgImg};
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  transition: all 0.3s ease-in-out;
`;

export const OverlayContent = styled(Box)`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

export const VideoTitle = styled(FlexDiv)`
  position: absolute;
  left: 0;
  top: 0;
  align-items: center;
`;

export const ChannelLogo = styled(Avatar)`
  margin: 0 16px 0 0;
  box-shadow: 0 0 0 2px rgba(${({ theme }) => theme.colors.shadows.white}, 1);
  padding: 0;
  border-radius: 50%;
  overflow: hidden;
  height: 32px;
  width: 32px;
  .image-box {
    width: 100%;
    height: 100%;
    margin: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const VideoMetadata = styled(FlexDiv)`
  position: absolute;
  left: 0;
  bottom: 0;
  .duration {
    margin-right: 10px;
  }
`;

export const StyledAction = styled(FlexDiv)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  p {
    display: flex;
    align-items: center;
    text-align: center;
  }
`;
export const VideoText = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
`;
